import { Components } from "@thisgorilla/primate-ds";
import { useRef } from "react";
import styled, { useTheme } from "styled-components";

import { validAudioFileTypes, validVideoFileTypes } from "../../../../utils";
import { FlexColumnCenter } from "../../../Common/Styles";
import { UploadProps } from "./Upload";
import { Loader } from "../../../Common";

const Upload = ({
  iconType,
  onClose,
  title,
  fileType,
  onUpload,
  onDrop,
  isUploading,
}: UploadProps.IProps) => {
  const { typography } = useTheme();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const validFileTypes: Record<UploadProps.FileType, string[]> = {
    audio: validAudioFileTypes,
    video: validVideoFileTypes,
  };

  return (
    <Container>
      <UploadContainer
        onClick={() => fileInputRef.current?.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={onDrop}
      >
        <Components.IconButton
          iconType={iconType}
          disabled={false}
          size="Small"
          kind="Secondary"
          onClick={() => {}}
        />
        <Components.Text
          style={{ tokenStyle: typography.Body.S }}
          text={title}
          fontWeight="font-weight-semibold"
          lineHeight="line-height-50"
        />
        <CloseButtonWrapper>
          <Components.IconButton
            iconType="X"
            disabled={false}
            size="Small"
            kind="Secondary"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
          />
        </CloseButtonWrapper>
      </UploadContainer>
      <HiddenInput
        type="file"
        disabled={false}
        onChange={onUpload}
        ref={fileInputRef}
        accept={validFileTypes[fileType].join(",")}
      />
      {isUploading && <Loader />}
    </Container>
  );
};

export default Upload;

const UploadContainer = styled(FlexColumnCenter)`
  width: 100%;
  cursor: pointer;
  position: relative;
  height: 125px;
  padding: ${({ theme }) => theme.spacing["spacing-none"].value}
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  border: 1px dashed
    ${({ theme }) => theme.Color.border["ui-border-emphasize-brand"].value};
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  right: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;

const Container = styled.div`
  max-width: 906px;
  width: 100%;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  position: relative;
`;

const HiddenInput = styled.input`
  display: none;
`;
